import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Lock, Eye, EyeOff, ArrowLeft } from 'lucide-react';
import api from '../../lib/api';
import { toast } from 'sonner';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (!token) navigate('/login'); }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) { toast.error('Passwords do not match'); return; }
    if (password.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: password });
      setDone(true);
      toast.success('Password reset successful!');
    } catch (err) { toast.error(err.response?.data?.detail || 'Reset failed. Link may be expired.'); }
    finally { setLoading(false); }
  };

  if (!token) return null;

  if (done) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-icon">🔑</div>
          <h1>Password Reset!</h1>
          <p className="auth-subtitle">Your password has been changed successfully.</p>
          <button onClick={() => navigate('/login')} className="auth-button auth-button-primary" style={{ marginTop: 20 }}>Go to Login</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-icon">🔑</div>
        <h1>Reset Password</h1>
        <p className="auth-subtitle">Enter your new password</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <Lock size={18} />
            <input type={showPassword ? 'text' : 'password'} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 characters)"
              className="auth-input" required />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="input-icon-btn">
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <div className="input-group">
            <Lock size={18} />
            <input type={showPassword ? 'text' : 'password'} value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm new password"
              className="auth-input" required />
          </div>
          <button type="submit" disabled={loading} className="auth-button auth-button-primary">{loading ? 'Resetting...' : 'Reset Password'}</button>
        </form>
        <p className="auth-footer"><Link to="/login"><ArrowLeft size={14} /> Back to Login</Link></p>
      </div>
    </div>
  );
}